import React, { useCallback, useEffect, useState } from "react";
//import React, { useCallback, useState } from "react";

import { Alert, MobileStepper } from "@mui/material";
import Container from "@mui/material/Container";

import { useMessageProvider } from "../common/message-provider";
import { usePartnerAxios } from "../common/partner-axios";
import { LoadingPageLayout } from "../layout/LoadingPageLayout";
import { SummaryPage } from "./SummaryPage";
import { KitRegistrationPage } from "./kitregistration/KitRegistrationPage";
import { QuestionairePage } from "./questionaire/QuestionairePage";
import { Question, QuestionDefinitionDto, QuestionaireResponse, RegistrationInfoDto } from "./questionaire/questionaire-types";

const QuestionSetVersion = "20220713";

export const MainPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [questionDefinitions, setQuestionDefinitions] = useState<QuestionDefinitionDto[]>();
  const [questions, setQuestions] = useState<Question[]>([]);
  const [isLoadingQuestionaire, setIsLoadingQuestionaire] = useState(false);
  const [isSavingAnswerSet, setIsSavingAnswerSet] = useState(false);
  const partnerAxios = usePartnerAxios();
  const messageProvider = useMessageProvider();
  const [testKitCode, setTestKitCode] = useState("0");
 
  const [userId, setUserId] = useState<number>();
const[displayLanguageIsFrench,setDisplayLanguageIsFrench]=useState(false)
  const handleKitRegistrationSuccess = (testKitCode: string, userId: number) => {
    setTestKitCode(testKitCode);
    fetchQuestionDefinitions(testKitCode);
    console.log("testKitCode on submit",testKitCode)
   // setTestKitCode(testKitCode);
    setUserId(userId);
    setCurrentStep((v) => v + 1);
  };

  const checkIfMandatory = (questionDef: QuestionDefinitionDto, allQuestions: Question[]) => {
    if (questionDef.isMandatory === "Yes") {
      return true;
    }

    for (const questionKey in questionDef.mandatoryIf) {
      var question = allQuestions.find((q) => q.key === questionKey);
      if (!question) {
        continue;
      }

      const requiredAnswerKeys = questionDef.mandatoryIf[questionKey];

      if (question.answers.every((a) => !requiredAnswerKeys.includes(a["key"]))) {
        return false;
      }
    }

    return true;
  };

  const submitAnswerSet = (questions: Question[]) => {
    setIsSavingAnswerSet(true);
    partnerAxios
      .post<QuestionaireResponse>("questionnaire/answers", { questionSetVersion: QuestionSetVersion, questions })
      .then((resp) => {
        registerTestKit(resp.data.transferOwnershipToken);
      })
      .catch((e) => {
        messageProvider.showError("Could not submit questionaire. Please try again.");
        setIsSavingAnswerSet(false);
      });
  };

  const registerTestKit = (transferOwnershipToken: string) => {
    const registrationInfo: RegistrationInfoDto = {
      ownerUserId: userId!,
      answerSetToken: transferOwnershipToken,
    };
    setIsSavingAnswerSet(true);
    partnerAxios
      .post(`/testkits/code|${encodeURIComponent(testKitCode)}/register`, registrationInfo)
      .then((resp) => {
        setCurrentStep(currentStep + 1);
      })
      .catch((e) => messageProvider.showError("Could not reigster test kit. Please try again."))
      .finally(() => setIsSavingAnswerSet(false));
  };

  const handleNextQuestionaire = (question: Question) => {
    const newQuestions = [...questions, question];

    // Check if the last step
    if (currentStep === questionDefinitions!.length) {
      submitAnswerSet(newQuestions);
      return;
    }

    // Remove questionnaire if necessary
    const definition = questionDefinitions![currentStep];
    if (!checkIfMandatory(definition, newQuestions)) {
      const copyQuestionDefinitions = [...questionDefinitions!];
      copyQuestionDefinitions.splice(currentStep, 1);
      setQuestionDefinitions(copyQuestionDefinitions);
    }

    setQuestions(newQuestions);
    setCurrentStep(currentStep + 1);
  };

  const fetchQuestionDefinitions  = useCallback((testKitCode) => {
    console.log("testKitCode In function",testKitCode)
    setIsLoadingQuestionaire(true);
    var formPayload = new FormData();

      var formPayload = new FormData();
      formPayload.append("testKitCode", testKitCode)
      partnerAxios
      .post('questionnaire/current',formPayload)      
      .then((resp) => {
   
        resp.data.forEach(function (value: any, i: any) {
      
          var question_key=value.key;
          let result = question_key.includes("_french");
          setDisplayLanguageIsFrench(result)
          if(result)
          {
          
            var no_french_key = question_key.replace('_french','');
            resp.data[i].key=no_french_key
          }         
         
      });
      
        
        const allQuestionDefs = resp.data as QuestionDefinitionDto[];

          setQuestionDefinitions(allQuestionDefs.filter((q) => q.isMandatory === "Yes" || q.isMandatory === "Conditional"));
         
        return setQuestionDefinitions(allQuestionDefs.filter((q) => q.isMandatory === "Yes" || q.isMandatory === "Conditional"));

      })
      .catch((e) => {
        setQuestionDefinitions([]);
      })
      .finally(() => setIsLoadingQuestionaire(false));
  }, [partnerAxios]);

  useEffect(() => {
    fetchQuestionDefinitions(testKitCode);
  }, [fetchQuestionDefinitions]);
 

  return (
    <Container maxWidth="md">
      {questionDefinitions && questionDefinitions.length > 0 && (
       
      // {questionDefinitions  && (
        <>
          <MobileStepper
            variant="dots"
            steps={questionDefinitions.length + 2}
            position="static"
            activeStep={currentStep}
            nextButton={<div />}
            backButton={<div />}
            sx={{ marginBottom: 4 }}
          />
          {currentStep === 0 && <KitRegistrationPage onSuccess={handleKitRegistrationSuccess} />}
          {0 < currentStep && currentStep <= questionDefinitions.length && (
            <QuestionairePage questionDefinition={questionDefinitions[currentStep - 1]} isFrenchLanguage={displayLanguageIsFrench} onNext={handleNextQuestionaire} isSaving={isSavingAnswerSet}  />
          )}
          {currentStep > questionDefinitions.length && <SummaryPage testKitCode={testKitCode} language={displayLanguageIsFrench} />}
        </>
      )}

      {questionDefinitions && questionDefinitions.length === 0 && <Alert severity="error">Could not load questionnaire. Please try again!</Alert>}

      {isLoadingQuestionaire && <LoadingPageLayout />}
    </Container>
  );
};
